import { Component, OnInit, ViewChild, Injector } from '@angular/core';

import { SecondPageEditBase, UserService, ExportService } from 'vnpost-shared';
import { FileUpload } from 'primeng/fileupload';
import { SaleRecordService } from '../../services/sale-record.service';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-import-sale-record',
  templateUrl: './import-sale-record.component.html',
  styleUrls: ['./import-sale-record.component.css'],
})
export class ImportSaleRecordComponent
  extends SecondPageEditBase
  implements OnInit
{
  @ViewChild('fileControl') fileControl: FileUpload;
  rawFileName = '';
  isUploading = false;
  uploadedFiles: any[] = [];
  constructor(
    protected _saleRecordService: SaleRecordService,
    protected _injector: Injector,
    protected messageService: MessageService,
    protected _exportService: ExportService
  ) {
    super(_saleRecordService, _injector);
  }

  onShowPopup() {
    this.uploadedFiles = [];
  }

  ngOnInit() {
  }

  myUploader(event: any) {
    const formData = new FormData();
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    if (this.uploadedFiles.length > 0) {
      this.submitting = true;
      this.isUploading = true;
      formData.append(
        'file',
        this.uploadedFiles[0],
        this.uploadedFiles[0].name
      );
      this._saleRecordService
        .importFile(formData)
        .then((rs) => {
          this.uploadedFiles = [];
          if (rs.file) {
            var base64Data = rs?.file?.fileContents;
            const base64DataCleaned = base64Data.replace(/^data:([A-Za-z-+/]+);base64,/, '');
            const blob = this.base64ToBlob(base64DataCleaned, rs?.file?.contentType)
            saveAs(blob, `ImportHosobanhang_error.xlsx`);
          }
          this._notifierService.showSuccess(rs.data);
          this.submitting = false;
          this.isUploading = false;
          this.closePopupMethod(true);
        })
        .catch((err) => {
          console.log('Có lỗi xảy ra, vui lòng thử lại ' + err);
          this._notifierService.showHttpUnknowError();
          this.submitting = false;
          this.isUploading = false;
        });
    }
  }

  base64ToBlob(base64Data: string, contentType: string): Blob {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  downloadForm() {
    const link = document.createElement('a');
    link.href = './assets/template/ImportHosobanhang.xlsx'; // Đường dẫn tới file mẫu
    link.download = 'ImportHosobanhang.xlsx'; // Tên file khi tải xuống
    link.click();
  }
  onUpload() {
    this.fileControl.upload();
  }
  onClear() {
    this.uploadedFiles = [];
  }
}
